import React from 'react';
import _ from 'lodash';
import * as Styled from '../../styled';
import { InvestmentFilterElements } from '../InvestmentFilterElements';

import Select from '../../../../common/Select/Select';
import { FundOption } from '../InvestmentFilters';

interface Props {
	investmentOptions: string[];
	initialInvestmentOptions: FundOption[];
	formikProps: any;
}

const InvestmentOptionsFilter = (props: Props) => {
	const { setFieldValue } = props.formikProps;

	const handleChange = (e: any) => {
		let selectedOptions = _.filter(e.target.options, 'selected');
		setFieldValue(
			'investmentOptions',
			selectedOptions.map(option => option.value)
		);
	};

	return (
		<React.Fragment>
			<Styled.BottomFilterLabel
				id={InvestmentFilterElements.investmentOptionsFilterId}
				label="Investment options"
			>
				<React.Fragment>
					<Select
						name="investmentOptions"
						id={`field-${InvestmentFilterElements.investmentOptionsFilterId}`}
						onChange={handleChange}
						value={props.investmentOptions}
						options={props.initialInvestmentOptions}
						dataId={`field-${InvestmentFilterElements.investmentOptionsFilterId}`}
						multiple={true}
						ariaLabelledby={`label-${InvestmentFilterElements.investmentOptionsFilterId}`}
						ariaDescribedby={`help-${InvestmentFilterElements.investmentOptionsFilterId}`}
					/>
					<Styled.MultiSelectHelper
						id={`help-${InvestmentFilterElements.investmentOptionsFilterId}`}
					>
						(Press Ctrl key to select multiple options or to deselect options)
					</Styled.MultiSelectHelper>
				</React.Fragment>
			</Styled.BottomFilterLabel>
		</React.Fragment>
	);
};

export default InvestmentOptionsFilter;
